// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form-container {
  padding: 2rem 0.7rem 2.8rem 0.7rem;
  background-color: #f0f4fe;
}

.survey-form-container .btn-submit-container {
  background-color: transparent;
  display: flex;
  justify-content: flex-end;
}

.survey-form-container .btn-submit-container button {
  padding: 0.7rem 2rem;
  border: none;
  border-radius: 0.2rem;
  background-color: #758ed6;
  color: white;
  box-shadow: 1px 1px lightgray;
  font-weight: 600;
}

.survey-form-container select:hover,
.survey-form-container .btn-submit-container button:hover {
  cursor: pointer;
}

.survey-form-container .btn-submit-container button > i {
  display: block;
  margin-right: 8px;
  font-style: normal;
}

.survey-form-container > * {
  background-color: white;
  padding: 1rem 1rem 1.5rem 1rem;
  border-radius: 0.3rem;
}

.survey-form-container > *:not(:first-child) {
  margin-top: 1rem;
}

.survey-form-container > article {
  padding: 1.2rem 1.2rem;
}

.survey-form-container article .slaves {
  padding: 1rem 0;
  border-top: 1px solid #3131;
}

.survey-form-container .title {
  margin-top: 2rem;
  margin-bottom: 0px !important;
  padding: 0px !important;
  background-color: transparent;
}

.survey-form-container .group > *,
.survey-form-container .checkbox {
  padding: 0.2rem;
  width: 100%;
}

.survey-form-container .group > * label,
.survey-form-container .checkbox label {
  margin-left: 0.4rem;
}

.survey-form-container select {
  font-size: 1rem;
  width: 100%;
  border-color: #3131;
  border-radius: 0.2rem;
  padding: 0.5rem;
  background-color: transparent;
  margin-bottom: 0.5rem;
}

.survey-form-container .question .message-field-required {
  font-style: normal;
  position: absolute;
  padding: 0.5rem 0.7rem;
  top: -1.6rem;
  right: 0;
  color: rgba(242, 96, 85);
  border-radius: 0.3rem;
  font-size: 0.77rem;
}

.survey-form-container .question {
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/Survey/style/survey.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".survey-form-container {\n  padding: 2rem 0.7rem 2.8rem 0.7rem;\n  background-color: #f0f4fe;\n}\n\n.survey-form-container .btn-submit-container {\n  background-color: transparent;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.survey-form-container .btn-submit-container button {\n  padding: 0.7rem 2rem;\n  border: none;\n  border-radius: 0.2rem;\n  background-color: #758ed6;\n  color: white;\n  box-shadow: 1px 1px lightgray;\n  font-weight: 600;\n}\n\n.survey-form-container select:hover,\n.survey-form-container .btn-submit-container button:hover {\n  cursor: pointer;\n}\n\n.survey-form-container .btn-submit-container button > i {\n  display: block;\n  margin-right: 8px;\n  font-style: normal;\n}\n\n.survey-form-container > * {\n  background-color: white;\n  padding: 1rem 1rem 1.5rem 1rem;\n  border-radius: 0.3rem;\n}\n\n.survey-form-container > *:not(:first-child) {\n  margin-top: 1rem;\n}\n\n.survey-form-container > article {\n  padding: 1.2rem 1.2rem;\n}\n\n.survey-form-container article .slaves {\n  padding: 1rem 0;\n  border-top: 1px solid #3131;\n}\n\n.survey-form-container .title {\n  margin-top: 2rem;\n  margin-bottom: 0px !important;\n  padding: 0px !important;\n  background-color: transparent;\n}\n\n.survey-form-container .group > *,\n.survey-form-container .checkbox {\n  padding: 0.2rem;\n  width: 100%;\n}\n\n.survey-form-container .group > * label,\n.survey-form-container .checkbox label {\n  margin-left: 0.4rem;\n}\n\n.survey-form-container select {\n  font-size: 1rem;\n  width: 100%;\n  border-color: #3131;\n  border-radius: 0.2rem;\n  padding: 0.5rem;\n  background-color: transparent;\n  margin-bottom: 0.5rem;\n}\n\n.survey-form-container .question .message-field-required {\n  font-style: normal;\n  position: absolute;\n  padding: 0.5rem 0.7rem;\n  top: -1.6rem;\n  right: 0;\n  color: rgba(242, 96, 85);\n  border-radius: 0.3rem;\n  font-size: 0.77rem;\n}\n\n.survey-form-container .question {\n  position: relative;\n  z-index: 0;\n  width: 100%;\n  padding: 0 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
